// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__38zgR","title":"ClientInsurance_title__2t2QI","itemText":"ClientInsurance_itemText__3ZVcQ"};